<template>
  <b-modal
    :title="props.title"
    body-class="simple-rename-modal-body"
    header-close-content=""
    v-model="localShow"
    @ok="confirmHandler"
    @show="showHandler"
    @cancel="cancelRename">
    <div class="simple-rename-modal-container">
      <b-form-group label="Name">
        <b-input
          :max="maxCharactersName"
          v-model="internValue"
          data-cy="advance-search-add-text"
          v-tooltip="validationFeedbacks"
          :class="{ 'border-danger': validationFeedbacks }"
          ref="renameInput"
          @keydown.prevent.enter="
            () => {
              confirmHandler();
              localShow = false;
            }
          " />
      </b-form-group>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-btn @click="ok" data-cy="advance-search-add-btn" variant="primary" :disabled="validationFeedbacks || !hasNameChanged">{{ props.okButtonText }}</b-btn>
      <b-btn @click="cancel" data-cy="advance-search-cancel-btn">{{ $t("Cancel") }}</b-btn>
    </template>
  </b-modal>
</template>
<script setup lang="ts">
import { AdvancedSearchEntry } from "@medapro-types/AdvancedSearch/AdvancedSearch";
import { setElementFocus } from "@util/focusManager";
import { computed, nextTick, ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  value: string;
  show: boolean;
  title: string;
  maxCharactersName?: number;
  okButtonText: string;
  savedSearchList: AdvancedSearchEntry[];
  selectedSearchId: string;
}>();
const emits = defineEmits(["input", "update:show", "confirm", "cancel"]);
const internValue = ref<string>("");
const { t: $t } = useI18n();
const localShow = computed({
  get: () => props.show,
  set: (nv) => emits("update:show", nv)
});

const renameInput = ref<any>();

const confirmHandler = () => {
  emits("input", internValue.value);
  emits("confirm", internValue.value);
};

const cancelRename = () => emits("cancel", true);

const hasNameChanged = computed(() => {
  return props.savedSearchList.find((x) => x.advancedSearchId == props.selectedSearchId)?.name != internValue.value;
});

const validationFeedbacks = computed(() => {
  const isNameEmpty = internValue.value == "" || internValue.value == null;
  const isDuplicateNameExists =
    internValue.value &&
    props.savedSearchList.filter(
      (x) => x.name && x.name != "" && x.advancedSearchId != props.selectedSearchId && x.name.toLowerCase() == internValue.value.toLowerCase()
    ).length > 0;
  const isNameLengthExceeds = internValue.value.length > 128;

  if (isNameEmpty) return $t("validation.valueRequired", { field: $t("name") });
  else if (isDuplicateNameExists)
    return $t("validation.duplicateExists", {
      field: $t("name")
    });
  else if (isNameLengthExceeds)
    return $t("validation.lengthExceeds", {
      field: $t("name", 1),
      length: 128
    });
  else return null;
});

const showHandler = () => {
  internValue.value = props.value;

  //this nextTick and Timeout is necessary because of the modal. If it's not there the focus won't happen.
  nextTick(() => {
    setTimeout(() => {
      const inputHTMLElemnt = renameInput.value?.$el;
      if (inputHTMLElemnt) {
        setElementFocus(inputHTMLElemnt, true);
      }
    }, 100);
  });
};
</script>
